import { useTheme } from '@emotion/react';
import { useState, useEffect } from 'react';
import { useMedia } from '@packlink/utils';
import { Typography } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { DropOffAddressInfo } from './DropOffAddressInfo.js';
import { getDropOffStyles, getDropOffTitleStyles, getDropOffDescriptionStyles, getDropOffMapStyles } from './DropOffStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Map } from '../Map/Map.js';

let DropOffTheme = /*#__PURE__*/function (DropOffTheme) {
  DropOffTheme["MOBILE"] = "mobile";
  DropOffTheme["DEFAULT"] = "default";
  return DropOffTheme;
}({});
const DropOff = _ref => {
  let {
    allowClose = false,
    theme = DropOffTheme.DEFAULT,
    addresses,
    markerIcon,
    senderAddressMarker,
    titleLocizeKey,
    onSelect
  } = _ref;
  const {
    t
  } = useTranslation();
  const [selected, setSelected] = useState(null);
  const [mapCenterPos, setMapCenterPos] = useState(null);
  const tenantTheme = useTheme();
  const isMobile = useMedia(`(max-width: ${tenantTheme.breakPoints.tablet}px)`);
  useEffect(() => {
    const firstAddress = addresses.length ? addresses[0] : null;
    if (firstAddress) {
      setSelected(addresses[0]);
    }
  }, [addresses]);
  const onMarkerSelect = markerId => {
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(markerId);
    const selected = addresses.find(_ref2 => {
      let {
        id
      } = _ref2;
      return id === markerId;
    });
    if (selected) {
      setMapCenterPos({
        lat: selected.lat,
        lng: selected.lng
      });
      setSelected(selected);
    }
  };
  const close = event => {
    event.preventDefault();
    setSelected(null);
  };
  const includeSenderMarker = (addresses, senderAddressMarker) => {
    return senderAddressMarker ? [...addresses, senderAddressToDropOffPoint(senderAddressMarker)] : [...addresses];
  };
  const senderAddressToDropOffPoint = senderAddressMarker => ({
    cursor: 'grab',
    customMarkerIcon: senderAddressMarker === null || senderAddressMarker === void 0 ? void 0 : senderAddressMarker.markerIcon,
    id: senderAddressMarker === null || senderAddressMarker === void 0 ? void 0 : senderAddressMarker.id,
    lat: senderAddressMarker.lat,
    lng: senderAddressMarker.lng
  });
  const dropOffPointToMapMarker = _ref3 => {
    let {
      lat,
      lng,
      customMarkerIcon,
      ...rest
    } = _ref3;
    return {
      icon: customMarkerIcon,
      position: {
        lat: lat,
        lng: lng
      },
      ...rest
    };
  };
  const addressesWithSenderIncluded = includeSenderMarker(addresses, senderAddressMarker);
  const addressesAsMapMarkers = addressesWithSenderIncluded.map(address => dropOffPointToMapMarker(address));
  return jsxs("div", {
    css: getDropOffStyles(theme),
    children: [jsx(Typography, {
      css: getDropOffTitleStyles(theme),
      variant: "heading5",
      children: titleLocizeKey ? t(titleLocizeKey) : t('drop-off.title')
    }), jsx(Typography, {
      css: getDropOffDescriptionStyles(theme),
      component: "p",
      variant: "body2",
      children: t('drop-off.description')
    }), selected && jsx(DropOffAddressInfo, {
      theme: theme,
      selected: selected,
      allowClose: allowClose,
      onDropOffPointClose: close
    }), jsx("div", {
      css: getDropOffMapStyles(theme),
      children: jsx(Map, {
        zoomControl: !isMobile,
        markers: addressesAsMapMarkers,
        onMarkerClick: onMarkerSelect,
        mapCenterPos: mapCenterPos,
        markerIcon: markerIcon
      })
    })]
  });
};

export { DropOff, DropOffTheme };
//# sourceMappingURL=DropOff.js.map
